import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Managing() {
    return (
        <OnboardingBody title='Managing your sources in settings'>
            <p>
                Account administrators can configure existing sources or create new ones from the
                &quot;Channels & sources&quot; page in Company settings.
            </p>
        </OnboardingBody>
    );
}
